import { render, staticRenderFns } from "./MedisGs1RowsDataTable.vue?vue&type=template&id=e5d5a08c&"
import script from "./MedisGs1RowsDataTable.vue?vue&type=script&lang=ts&"
export * from "./MedisGs1RowsDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports